import { AircraftCategory } from './aircraft-category';

export class Aircraft {
  aircraftId: number;
  category: AircraftCategory;
  modelName: string;
  tailNumber: string;
  marketableSeatsCount: number;
  operatorApprovalExpirationDate: Date = null;
  insuranceApproved = false;
  deleted = false;
  completed = false;
  insuranceRestrictionApprover = false;
  requiresOwnerApproval = false;

  getInsuranceApproved(): boolean {
    return this.insuranceApproved;
  }

  setInsuranceApproved(insuranceApproved: boolean): Aircraft {
    this.insuranceApproved = insuranceApproved;
    return this;
  }

  getOperatorApprovalExpiration(): Date {
    return this.operatorApprovalExpirationDate;
  }

  setOperatorApprovalExpiration(operatorApprovalExpirationDate: Date): Aircraft {
    this.operatorApprovalExpirationDate = operatorApprovalExpirationDate;
    return this;
  }

  getCategory(): AircraftCategory {
    return this.category;
  }

  setCategory(category: AircraftCategory): Aircraft {
    this.category = category;
    return this;
  }

  getAircraftId(): number {
    return this.aircraftId;
  }

  setAircraftId(aircraftId: number): Aircraft {
    this.aircraftId = aircraftId;
    return this;
  }

  getModelName(): string {
    return this.modelName;
  }

  setModelName(modelName: string): Aircraft {
    this.modelName = modelName;
    return this;
  }

  getTailNumber(): string {
    return this.tailNumber;
  }

  setTailNumber(tailNumber: string): Aircraft {
    this.tailNumber = tailNumber;
    return this;
  }

  getMarketableSeatsCount(): number {
    return this.marketableSeatsCount;
  }

  setMarketableSeatsCount(marketableSeatsCount: number): Aircraft {
    this.marketableSeatsCount = marketableSeatsCount;
    return this;
  }

  getDeleted(): boolean {
    return this.deleted;
  }

  setDeleted(value: boolean): Aircraft {
    this.deleted = value;
    return this;
  }

  getCompleted(): boolean {
    return this.completed;
  }

  setCompleted(value: boolean): Aircraft {
    this.completed = value;
    return this;
  }

  getInsuranceRestrictionApprover(): boolean {
    return this.insuranceRestrictionApprover;
  }

  setInsuranceRestrictionApprover(value: boolean): Aircraft {
    this.insuranceRestrictionApprover = value;

    return this;
  }
  
  getRequiresOwnerApproval(): boolean {
    return this.requiresOwnerApproval;
  }

  setRequiresOwnerApproval(requiresOwnerApproval: boolean): Aircraft {
    this.requiresOwnerApproval = requiresOwnerApproval;

    return this;
  }
}
